module.exports = __webpack_public_path__ + "static/media/red.c9efe144.png";